import { confirmedFeatures, roadmapFeatures } from "../data/marketingContent";
import { SectionHeading } from "./SectionHeading";

export function FeatureGrid() {
  return (
    <section id="features" className="section-wrap">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Feature overview"
          title="A signage control center built from the real platform surface."
          body="The live product already covers screen operations, content management, runtime preview, role-based access, billing, and auditability. Planned integrations are marked separately."
          center
        />

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {confirmedFeatures.map((feature) => {
            const Icon = feature.icon;
            return (
              <article key={feature.title} className="feature-card">
                <div className="flex items-start justify-between gap-4">
                  <span className="feature-icon">{Icon ? <Icon size={22} /> : null}</span>
                  {feature.status ? (
                    <span className={`status-chip status-chip-${feature.tone ?? "available"}`}>
                      {feature.status}
                    </span>
                  ) : null}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.body}</p>
              </article>
            );
          })}
        </div>

        <div className="roadmap-panel">
          <div>
            <p className="section-eyebrow">Roadmap</p>
            <h3>Planned and designed-for areas</h3>
          </div>
          <div className="grid gap-4 md:grid-cols-3">
            {roadmapFeatures.map((item) => (
              <div className="roadmap-item" key={item.title}>
                <strong>{item.title}</strong>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
